import verberWordVariations from '@glass/shared/modules/content/staticVariations/verbWords/verberWordVariations';

const builderWordVariations = [...verberWordVariations, 'tool', 'online', 'download', 'help'];

export default builderWordVariations;
